import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { SvcFormCustomFieldHttpClient } from './svc-form-custom-field-http-client';
import { SvcFormCustomFieldValue, SvcFormCustomFieldValueData } from './svc-form-custom-field.interface';
import { SvcCustomFieldList } from './svc-form-custom-field.interface';

@Injectable()
export class SvcFormCustomFieldValueService {
  #http = inject(SvcFormCustomFieldHttpClient);

  /**
   * Endpoint for creating (insert) or updating a Value.
   *
   * @param customFieldValue - The custom field Value to register or update.
   * @returns An observable of a boolean indicating the success of the operation.
   */
  public updateCustomFieldValue(customFieldValue: SvcFormCustomFieldValue, applicationId: string = undefined, siteId: number = undefined): Observable<boolean> {
    return this.#http.post('/CustomFieldValue', {
      ...customFieldValue,
      applicationId: applicationId ?? this.#http.applicationId,
      siteId: siteId ?? this.#http.siteId,
    });
  }

  public getCustomFieldValue(
    featureName: string,
    registryId: number | null | undefined,
    systemReferenceId: number,
    featureId: string,
    applicationId: string = undefined,
    siteId: number = undefined
  ): Observable<SvcFormCustomFieldValueData> {
    return this.#http.get('/CustomFieldValue', {
      params: {
        applicationId: applicationId ?? this.#http.applicationId,
        siteId: siteId ?? this.#http.siteId,
        ...(featureName ? { featureName } : {}),
        ...(featureId ? { featureId } : {}),
        ...(registryId != null ? { registryId } : {}),
        systemReferenceId,
      },
    });
  }

  public getCustomField(
    featureName: string,
    registryId: number | null | undefined,
    featureId: string,
    applicationId: string = undefined
  ): Observable<SvcCustomFieldList> {
    return this.#http.get('/CustomField', {
      params: {
        applicationId: applicationId ?? this.#http.applicationId,
        siteId: this.#http.siteId,
        isActive: true,
        ...(featureName ? { featureName } : {}),
        ...(featureId ? { featureId } : {}),
        ...(registryId != null ? { registryId } : {}),
      },
    });
  }
}
